<template>
  <div v-bind="$attrs"><slot></slot></div>
</template>

<script>
export default {
  name: 'ResizeWatcher',
  data() {
    return {
      observer: null
    }
  },
  mounted() {
    this.observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.contentBoxSize) {
          this.$emit('customresize')
        }
      }
    })
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
}
</script>
